// Port of api/fuel/app/classes/controller/api/monty/accounts/reset.php
export default function() {
	return Promise.reject({ error: 'This action is not available offline.', offline: true })
}
